<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="$t('Global.Main.reportsMaganement')"
        icon="mdi-phone" />
    <v-container fluid class="fill-width mb-5">
      <report-filters
            class="fill-width mb-5"
            :reportTypes="reportTypes"
            :granularityTypes="granularityTypes"
            :agents="agents"
            :queues="queues"
            :groups="groups"
            @dataFilters="recoverRequestData"
        />
      <v-sheet color="background" class="px-2 mb-5 neu-glow" >
        <v-list color="background">
          <v-list-item color="background" :disabled="!dataToView?.type" >
            <span class="text-subtitle-2 mr-2">{{ $t('Global.Reports.reportType') }}:  </span>  {{  dataToView.type ? $t(`Global.Reports.literal_${dataToView.type }`) : '' }}
          </v-list-item>
          <v-list-item v-if="!!dataToView?.granularity" color="background" :disabled="!dataToView?.granularity">
            <span class="text-subtitle-2 mr-2">{{ $t('Global.Reports.granularityType') }}:</span> {{ dataToView.granularity ? $t(`Global.Reports.literal_${dataToView.granularity }`) : '' }}
          </v-list-item>
          <v-list-item v-if="!!dataToView?.date" color="background" :disabled="!dataToView?.date">
            <span class=" text-subtitle-2 mr-2">{{ $t('Global.Reports.rangeDate') }}:</span> {{ dataToView.date }}
          </v-list-item>
          <v-list-item v-if="!!dataToView?.agentId"  color="background" :disabled="!dataToView?.agentId">
            <span class=" text-subtitle-2 mr-2">Agente:</span> {{ dataToView.agentId }}
          </v-list-item>
          <v-list-item v-if="!!dataToView?.remoteParty"  color="background" :disabled="!dataToView?.remoteParty">
            <span class=" text-subtitle-2 mr-2">Telefono:</span> {{ dataToView.remoteParty }}
          </v-list-item>
          <v-list-item v-if="!!dataToView?.queueId"  color="background" :disabled="!dataToView?.queueId">
            <span class=" text-subtitle-2 mr-2">Cola:</span> {{ dataToView.queueId }}
          </v-list-item>
          <v-list-item v-if="!!dataToView?.groupId"  color="background" :disabled="!dataToView?.groupId">
            <span class=" text-subtitle-2 mr-2">Agrupación:</span> {{ dataToView.groupId }}
          </v-list-item>
        </v-list>
      </v-sheet>
      <v-sheet color="background" class="px-2">
        <!-- Button obtener informe  -->
        <v-btn color="primary" class="neu-glow" @click="downloadReport" right small :disabled="!canBeSend" >
          <v-icon color="white" class="mr-2" left>
            mdi-microsoft-excel
          </v-icon>
          {{ $t('Global.Reports.getReport') }}</v-btn>
      </v-sheet>
    </v-container>
    <confirm-dialog
        ref="confirmDialog"
        :title="confirmDialogTitle"
        :message="confirmDialogMessage"
      />
    <v-snackbar
        v-model="snackbar"
        absolute
        top
        right
        :timeout="snackbarTimeout"
        :color="snackbarColor"
        class="mt-6"
    >
      <span>{{ snackbarMessage }}</span>
      <v-icon class="ml-2" dark>{{ snackbarIcon }}</v-icon>
      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar = false"
        >
          {{ $t("Global.ConfirmDialog.buttonTextClose") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import ReportsApi from "@/mixins/Services/ReportsApi";
import GroupApi from "@/mixins/Services/GroupApi";
import snackBar from "@/mixins/snackBarMixin";
import loader from "@/mixins/Loader";
import ReportFilters from "./ReportFilters.vue"
import ConfirmDialog from "@/components/UI/Dialogs/ConfirmDialog";
import {mapGetters} from 'vuex'
import Utils from "@/mixins/Utils";
import Logout from "@/mixins/Logout";


export default {
  name: "Reports",
  components: {
    ConfirmDialog,
    ReportFilters
  },
  mixins: [ ReportsApi, snackBar, loader, Utils, Logout, GroupApi],
  data() {
    return {
      confirmDialogTitle: "",
      confirmDialogMessage: null,
      granularityTypes:[
        {
          granularityTypeId: 1,
          granularityTypeName: 'horas',
          granularityTypeDesc: 'granularity TypeDesc 1'
        },
        {
          granularityTypeId: 2,
          granularityTypeName: 'dias',
          granularityTypeDesc: 'granularity TypeDesc 2'
        },
        {
          granularityTypeId: 3,
          granularityTypeName: 'semanas',
          granularityTypeDesc: 'granularity TypeDesc 3'
        }
      ],
      reportTypes: [
          {
            reportTypeId: 1,
            reportTypeName: 'Informe CDR',
            reportTypeDesc: 'Informe CDR',

          },
          {
            reportTypeId: 2,
            reportTypeName: 'Desglose ACD',
            reportTypeDesc: 'Informe de Calidad del Servicio - Desglose ACD',

          },
          {
            reportTypeId: 3,
            reportTypeName: 'Servicio - Desglose Fecha',
            reportTypeDesc: 'Informe de Calidad del Servicio - Desglose Fecha',

          },
          {
            reportTypeId: 4,
            reportTypeName: 'Desglose Agente',
            reportTypeDesc: 'Informe de Seguimiento de Agentes - Desglose Agente',

          },
          {
            reportTypeId: 5,
            reportTypeName: 'Seguimiento - Desglose Fecha',
            reportTypeDesc: 'Informe de Seguimiento de Agentes - Desglose Fecha',

          }
      ],
      maxIntervalTypes:[
        {
          maxIntervalTypeId: 1,
          maxIntervalTypeName: 'max_days_report',
          maxIntervalTypeDesc: 'Número máximo de días permitidos para la obtención de informes, granularidad diaria',
          maxIntervalTypeValue: 32
        },
        {
          maxIntervalTypeId: 2,
          maxIntervalTypeName: 'max_hours_report',
          maxIntervalTypeDesc: 'Número máximo de horas permitidas para la obtención de informes, granularidad horaria',
          maxIntervalTypeValue: 192
        },
        {
          maxIntervalTypeId: 3,
          maxIntervalTypeName: 'max_days_report_cdr',
          maxIntervalTypeDesc: 'Número máximo de días permitidos para la obtención de informes tipo CDR',
          maxIntervalTypeValue: 32
        }
      ],
      dataToSend: {
        type: null,
        from: null,
        to: null,
        granularity: null
      },
      dataToView:{},
      reportData: [], // Para almacenar los datos del informe
      reportHeaders: [], // Para almacenar los encabezados de la tabla
      agents: [],
      queues: [],
      groups: []
    }
  },
  computed: {
    ...mapGetters(['getReportTypes', 'getGranularityTypes', 'getMaxIntervalTypes']),
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp
    },
    canBeSend(){
      return this.dataToView.sendRequest
    }
  },
  methods: {
    recoverRequestData(data){
      this.dataToView = {
        type: data.report?.reportTypeName || null,
        date: data.date?.text || null,
        granularity: data.granularity?.granularityTypeName || null,
        sendRequest: data.sendRequest,
        agentId: data.agent?.agentName || null,
        remoteParty: data.tlf,
        queueId: data.queue?.nodeName || null,
        groupId: data.group?.groupName || null
      }
      this.dataToSend = {
        type: data.report?.reportTypeName || null,
        from: data.date?.from || null,
        to: data.date?.to || null,
        granularity: data.granularity?.granularityTypeName || null,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
        agentId: data.agent?.agentId || null,
        remoteParty: data.tlf || null,
        queueId: data.queue?.nodeId || null,
        groupId: data.group?.groupId || null
      }
    },
    async downloadReport() {
      this.confirmDialogTitle = this.$t("Global.Reports.downloadReport")
      const confirm = await this.$refs.confirmDialog.open()
      if (!confirm) return
      this.setLoader(true)
      var millisDifference = this.dataToSend.to-this.dataToSend.from
      // Exceed max hours
      if(this.dataToSend.granularity === 'HOURLY'){
        var hours = Math.floor(millisDifference / (1000*60*60))
        var maxValueHours = this.maxIntervalTypes?.find(element => element.maxIntervalTypeName === 'max_hours_report').maxIntervalTypeValue
        if(hours >= maxValueHours){
          this.setLoader(false)
          this.$emit('launch-snackbar', this.$t(`Global.Reports.exceed_max_hours_allowed`), 'error', "4000", 'mdi-alert-octagon')
          return null
        }
      }
      // Exceed max days
      else if(this.dataToSend.granularity === 'DAILY'){
        var days = Math.floor(millisDifference / (1000*60*60*24))
        var maxValueDays = this.maxIntervalTypes?.find(element => element.maxIntervalTypeName === 'max_days_report').maxIntervalTypeValue
        if(days >= maxValueDays){
          this.setLoader(false)
          this.$emit('launch-snackbar', this.$t(`Global.Reports.exceed_max_days_allowed`), 'error', "4000", 'mdi-alert-octagon')
          return null
        }
      }
      // Exceed max days (CDR)
      else if(this.dataToSend.type === 'CALL_DETAIL_RECORD'){
        var daysCdr = Math.floor(millisDifference / (1000*60*60*24))
        var maxValueCdr = this.maxIntervalTypes?.find(element => element.maxIntervalTypeName === 'max_days_report_cdr').maxIntervalTypeValue
        if(daysCdr >= maxValueCdr){
          this.setLoader(false)
          this.$emit('launch-snackbar', this.$t(`Global.Reports.exceed_max_days_allowed`), 'error', "4000", 'mdi-alert-octagon')
          return null
        }
      }
      try {
        const response = await this.getReport(this.dataToSend)
        const blob = new Blob([response.data], {type: response.data.type})
        let fileURL = window.URL.createObjectURL(blob)
        let fileLink = document.createElement("a");
        let headerLine = response.headers["content-disposition"];
        let filename = headerLine.split("=")[1];
        fileLink.href = fileURL;
        fileLink.setAttribute("download", filename);
        document.body.appendChild(fileLink);
        fileLink.click()
        this.launchSnackbar(this.$t("Global.Reports.successDownloadReport"), "success", "4000", "mdi-check-circle")
        this.setLoader(false)
      } catch (e) {
  console.error('[REPORTS][downloadReport] ERROR:', e)
  this.setLoader(false)

  try {
    const text = await e.response.data.text()
    const resErrorJson = JSON.parse(text)
    console.log("[REPORTS][downloadReport] Parsed Error:", resErrorJson)

    if (resErrorJson.errorCode === 402381) {
      this.$emit('launch-snackbar', this.$t(`Global.Error.c${resErrorJson.errorCode}`), 'error', "4000", 'mdi-alert-octagon')
      return
    }
  } catch (parseErr) {
    console.warn("[REPORTS][downloadReport] Error parsing JSON response:", parseErr)
    if (this.isErrorText(e)) {
      const errorCode = this.getErrorText(e)
      this.$emit(
        'launch-snackbar',
        this.$t(`Global.Error.c${errorCode}`),
        'error',
        "4000",
        'mdi-alert-octagon'
      )
    }
  }
}

    },
    async viewReport() {
    try {
        console.debug('[REPORTS][viewReport] Sending data:', this.dataToSend);
        const reportData = await this.visualizeReport(this.dataToSend); // Llama al método nuevo de reportApi
        console.debug('[REPORTS][viewReport] reportData:', reportData);

        if (reportData && Array.isArray(reportData)) {
            this.reportData = reportData; 
            this.reportHeaders = Object.keys(this.reportData[0]);
        } else {
            console.warn('[REPORTS][viewReport] No valid data returned');
            this.reportData = [];
            this.reportHeaders = [];
            this.$emit('launch-snackbar', this.$t('Global.Error.noData'), 'info', "4000", 'mdi-information');
        }
    } catch (e) {
        console.error('[REPORTS][viewReport] ERROR:', e);
        this.$emit('launch-snackbar', this.$t('Global.Error.generalError'), 'error', "4000", 'mdi-alert-octagon');
    }
},


    loadAgents() {
      try {
        this.setLoader(true)
        this.getAgents().then((r) => this.agents = r)
        this.setLoader(false)
      } catch (e) {
        console.error('[REPORTS][loadAgents] ERROR:', e)
        this.setLoader(false)
        if (this.isErrorText(e)) {
          const errorCode = this.getErrorText(e);
          this.$emit('launch-snackbar', this.$t(`Global.Error.c${errorCode}`), 'error', "4000", 'mdi-alert-octagon')
        }
      }
    },
    loadQueues() {
      try {
        this.setLoader(true)
        this.getQueues().then((r) => this.queues = r)
        this.setLoader(false)
      } catch (e) {
        console.error('[REPORTS][loadQueues] ERROR:', e)
        this.setLoader(false)
        if (this.isErrorText(e)) {
          const errorCode = this.getErrorText(e);
          this.$emit('launch-snackbar', this.$t(`Global.Error.c${errorCode}`), 'error', "4000", 'mdi-alert-octagon')
        }
      }
    },
    loadGroups() {
      try {
        this.setLoader(true)
        this.getGroups().then((r) => this.groups = r)
        this.setLoader(false)
      } catch (e) {
        console.error('[REPORTS][loadGroups] ERROR:', e)
        this.setLoader(false)
        if (this.isErrorText(e)) {
          const errorCode = this.getErrorText(e);
          this.$emit('launch-snackbar', this.$t(`Global.Error.c${errorCode}`), 'error', "4000", 'mdi-alert-octagon')
        }
      }
    },
  },
   async mounted() {
      this.reportTypes = this.getReportTypes || this.reportTypes
      this.granularityTypes = this.getGranularityTypes || this.granularityTypes
      this.maxIntervalTypes = this.getMaxIntervalTypes || this.maxIntervalTypes
      this.loadAgents()
      this.loadQueues()
      this.loadGroups()
   }

}
</script>

<style>
</style>

